import { mapActions, mapGetters } from 'vuex';
import {
  MAX_CHANNEL_SIDEBAR_WIDTH,
  MIN_CHANNEL_SIDEBAR_WIDTH,
} from '_lib/constants/channel';
import EventBus from '_lib/EventBus';

export default {
  data() {
    return {
      resizingWidth: false,
      startX: 0,
      initialWidth: 280,

      MAX_CHANNEL_SIDEBAR_WIDTH,
      MIN_CHANNEL_SIDEBAR_WIDTH,
    };
  },
  computed: {
    dragLineStyle() {
      return {
        left: 62 + this.initialWidth + 'px', // 62 = 66（房间列表宽度） - 4（拖拽线宽度） initialWidth = 频道列表宽度
      };
    },
    ...mapGetters(['channel_sidebar_width', 'popover_show']),
  },
  watch: {
    channel_sidebar_width: {
      handler(v) {
        this.initialWidth = v;
      },
      immediate: true,
    },
    resizingWidth(v) {
      EventBus.$emit('Change_Channel_Sidebar_Resize', v);
    },
  },
  beforeDestroy() {
    window.removeEventListener('mousemove', this.resizeDrag);
    window.removeEventListener('mouseup', this.stopResizeDragging);
  },
  methods: {
    startResizeChannelSideBar(event) {
      event.preventDefault();
      this.resizingWidth = true;
      this.startX = event.clientX;

      // 计算聊天框当前实际宽度
      this.$nextTick(() => {
        window.addEventListener('mousemove', this.resizeDrag);
        window.addEventListener('mouseup', this.stopResizeDragging);
      });
    },
    resizeDrag(event) {
      if (this.resizingWidth) {
        const diffX = this.startX - event.clientX;
        this.startX = event.clientX;
        this.initialWidth = Math.min(
          MAX_CHANNEL_SIDEBAR_WIDTH,
          Math.max(MIN_CHANNEL_SIDEBAR_WIDTH, this.initialWidth - diffX)
        );
        EventBus.$emit('resizeChannelSideBar', this.initialWidth);
      }
    },
    stopResizeDragging() {
      this.resizingWidth = false;
      window.removeEventListener('mousemove', this.resizeDrag);
      window.removeEventListener('mouseup', this.stopResizeDragging);
      this.SET_SETTING_DATA_PARAM({
        channel_sidebar_width: this.initialWidth,
      });
    },
    ...mapActions(['SET_SETTING_DATA_PARAM']),
  },
};
